module.exports = __webpack_public_path__ + "static/01-c8b62984d8a9fe8668bc78b64eba1e67.png";